import Swiper from "swiper"
import { find } from "utils/dom"
import axios from 'axios'
import showToastify from '../utils/toastify'
import "toastify-js/src/toastify.css"
import { findAll } from "../utils/dom"

export default function () {
	const Home = find("[js-page='invista_aqui']")
	if (!Home) return

	if (window.innerWidth <= 1024) {
		const swiperParceiroInvista = new Swiper(".swiper-parceiros", {
			spaceBetween: 8,
			centeredSlides: true,
			loop: true,
			autoplay: {
				delay: 4500,
				disableOnInteraction: false,
			}
		});
	}

	function showMessage(response) {
		const message = response.data ? response.data.message : response.message
		showToastify(message)
		contatoFormSubmit.reset()
		setTimeout(enabledBtn, 1000)
	}

	const btnSubmit = document.querySelector('.contact-form-invista button[type=submit]')

	function disabledBtn() {
		btnSubmit.disabled = true
		btnSubmit.classList.add('disabled')
	}

	function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.classList.remove('disabled')
	}

	function IsEmail(email) {
		const regex = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
		return regex.test(email);
	}

	const contatoFormSubmit = document.querySelector('.contact-form-invista');

	contatoFormSubmit &&
		contatoFormSubmit.addEventListener('submit', async function (event) {
			event.preventDefault()
			disabledBtn()

			const formData = new FormData()
			formData.append('nome', document.querySelector('.contact-form-invista .form-group input[name=nome]').value)
			formData.append('email', document.querySelector('.contact-form-invista .form-group input[name=email]').value)
			formData.append('telefone', document.querySelector('.contact-form-invista .form-group input[name=telefone]').value);

			document.querySelector('.email-error').innerText = "";

			if (formData.get('email') == '') {
				document.querySelector('.email-error').innerText = "O campo é obrigatório.";
				enabledBtn();
				return;
			}
			if (!IsEmail(formData.get('email'))) {
				document.querySelector('.email-error').innerText = "Email inválido";
				enabledBtn();
				return;
			}

			// reCAPTCHA dinâmico
			if (!window.grecaptcha || !window.site_key) {
				console.error('reCAPTCHA não carregado ou site_key ausente.');
				enabledBtn();
				return;
			}

			try {
				const token = await grecaptcha.execute(window.site_key, { action: 'submit' });
				formData.append('recaptcha_token', token);

				const url = '/invista-aqui-email/'
				axios
					.post(url, formData)
					.then((response) => showMessage(response))
					.catch((response) => showMessage(response))
			} catch (err) {
				console.error('Erro ao executar o reCAPTCHA:', err);
				enabledBtn();
				showToastify('Erro de segurança ao enviar. Tente novamente.');
			}
		})
}
